import Vue from "vue"; //引入vue
import Vuex from "vuex"; //引入vuex
Vue.use(Vuex);
//相当于data
//在组件中使用：this.$store.state.count
const getLocalStorage = (key, defaultData = "", dataType = "") => {
    const localStorageData = localStorage.getItem(key);
    // console.log(dataType, localStorageData, !!localStorageData);
    if (localStorageData) {
        if (dataType === "json") {
            return JSON.parse(localStorageData);
        } else {
            return localStorageData;
        }
    } else {
        return defaultData;
    }
};
const state = {
    count: 0,
    refsList: {},
    isLogin: getLocalStorage("isLogin", false) === "true",
    userInfo: getLocalStorage("userInfo", {}, "json"),
    token: getLocalStorage("token", ""), //token
    baseUrl: process.env.BASE_URL, //请求域名
    lang: getLocalStorage("lang", "zh"), //当前是中文还是英文  中文：zh;英文：en
    message: false,
    type: "",
    signupImg: true, //首页弹框图片
    chatbox: false //聊天弹框
};
//相当于methods
//在组件中使用：this.$store.commit("mutationsAddCount",20);
const mutations = {
    //更改弹框状态
    setSignupImg(state, valve) {
        return (state.signupImg = valve);
    },
    setChatbox(state, valve) {
        return (state.chatbox = valve);
    },
    mutationsAddCount(state, n = 0) {
        return (state.count += n);
    },
    mutationsReduceCount(state, n = 0) {
        return (state.count -= n);
    },
    setRefList(state, refsList = {}) {
        state.refsList = refsList;
    },
    //更改登录状态
    changeLogin(state, status) {
        return (state.isLogin = status);
    },
    //更改用户信息
    changeUser(state, info) {
        return (state.userInfo = info);
    },
    loginSuccess(state, data) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("isLogin", true);
        localStorage.setItem("userInfo", JSON.stringify(data.userInfo));
        for (const key in data) {
            state[key] = data[key];
        }
    },
    //修改消息
    changeMessage(state, status) {
        return (state.message = status);
    },
    //修改师资传值
    changeType(state, type) {
        return (state.type = type);
    }
};
//相当于computed
//在组件中使用：this.$store.getters.getterCount
const getters = {
    getterCount(state) {
        return state.count + 99;
    }
};
//异步操作
//在组件中使用：this.$store.dispatch("actionAddCount",30);
const actions = {
    actionAddCount(context, n = 0) {
        return context.commit("mutationsAddCount", n);
    },
    actionsReduceCount({ commit }, n = 0) {
        return commit("mutationsReduceCount", n);
    }
};
//modules -- 实现模块化
import moduleA from "./modules/moduleA.js";
import moduleB from "./modules/moduleB.js";
import metaModule from "./modules/metaInfo"

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        moduleA, //解构赋值的写法, moduleA:moduleA
        moduleB,
        metaModule
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js